import { Injectable } from '@angular/core';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { rentalObjectCommand } from '../../command/rental-object.command';
import { rentalObjectFormCommand } from '../../model/const/command';
import { AdvertiseRentalObjectCommandHandler } from './advertise-rental-object-command-handler.service';
import { CreateContractRentalObjectCommandHandler } from './create-contract-rental-object-command-handler.service';
import { LinkRentalObjectDocumentCommandHandler } from './link-rental-object-document-command-handler.service';
import { PrintStairCaseListCommandHandler } from './print-staircaselist-command-handler';
import { ShowRentalObjectDocumentsCommandHandler } from './show-rental-object-documents-command-handler.service';
import { ShowRentalObjectInvoicesCommandHandler } from './show-rental-object-invoices-command-handler';
import { PrintBrokerInformationCommandHandler } from './print-broker-information-command-handler.service';
import { ChangeRentalObjectCategoryCommandHandler } from './change-rental-object-category-command-handler.service';

@Injectable()
export class RentalObjectFormCommandHandlerResolver extends FormCommandHandlerResolver {
  constructor(createContractHandler: CreateContractRentalObjectCommandHandler,
    createHandler: CreateCommandHandler,
    deleteHandler: DeleteFormCommandHandler,
    showInvoicesHandler: ShowRentalObjectInvoicesCommandHandler,
    linkDocumentHandler: LinkRentalObjectDocumentCommandHandler,
    showDocumentHandler: ShowRentalObjectDocumentsCommandHandler,
    advertiseHandler: AdvertiseRentalObjectCommandHandler,
    printStairCaseListHandler: PrintStairCaseListCommandHandler,
    printBrokerInformationHandler: PrintBrokerInformationCommandHandler,
    changeCategoryHandler: ChangeRentalObjectCategoryCommandHandler,
  ) {
    super(createHandler, deleteHandler);
    this.addHandler(rentalObjectFormCommand.createContract, createContractHandler);
    this.addHandler(rentalObjectCommand.showInvoices, showInvoicesHandler);
    this.addHandler(rentalObjectCommand.linkDocument, linkDocumentHandler);
    this.addHandler(rentalObjectCommand.showDocuments, showDocumentHandler);
    this.addHandler(rentalObjectCommand.advertise, advertiseHandler);
    this.addHandler(rentalObjectCommand.showStairCaseList, printStairCaseListHandler);
    this.addHandler(rentalObjectCommand.printBrokerInformation, printBrokerInformationHandler);
    this.addHandler(rentalObjectCommand.changeCategory, changeCategoryHandler);
  }
}
